export class Accounts {
  static DEFAULT_NAME = 'Default Projects'
}
